import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import ResourcesList from './ResourcesList/ResourcesList';
import ResourceShow from './ResourceShow/ResourceShow';
import ResourceEdit from './ResourceEdit/ResourceEdit';
import ResourceCreate from './ResourceCreate/ResourceCreate';
import ResourceDelete from './ResourceDelete/ResourceDelete';

const Resources = ({ match }) => {
    return (
        <div className="Resources">
            <ContainerWrapper container="resources">
                <Route exact path={ match.path } component={ResourcesList} />
                <Route exact path={ `${ match.url }/new` } component={ResourceCreate} />
                <Route exact path={ `${ match.url }/show/:resourceId` } component={ResourceShow} />
                <Route exact path={ `${ match.url }/edit/:resourceId` } component={ResourceEdit} />
                <Route exact path={ `${ match.url }/delete/:resourceId` } component={ResourceDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Resources;
